// extracted by mini-css-extract-plugin
module.exports = {"text":"styles__text___jK4QH","replyTemplateTipContainer":"styles__replyTemplateTipContainer___18cwr","replyTipIconContainer":"styles__replyTipIconContainer___31C2U"};